// Global packages and components
import { removeDecimals } from '~/utils'

// Types
import type { ProductListingPriceValues } from '~/types'

interface PriceRangeFilterProps {
  min?: number
  max?: number
  start: number
  end: number
  setPriceValues: (e: ProductListingPriceValues) => void
}

// Main export
const PriceRangeFilter = ({
  min,
  max,
  start,
  end,
  setPriceValues,
}: PriceRangeFilterProps) => {
  return (
    <div className="flex gap-3">
      <div className="relative flex-1">
        <p className="pointer-events-none absolute left-4 top-1/2 mb-0 -translate-y-1/2 text-neutral-500">
          Min:
        </p>
        <input
          type="number"
          placeholder={min ? min.toString() : ''}
          className="w-full rounded-xl border border-neutral-300 bg-white py-3 pl-14 pr-4 focus:border-teal-green focus:outline-none"
          min={min ? removeDecimals(min) : undefined}
          max={max ? removeDecimals(max) : undefined}
          value={removeDecimals(start)}
          onChange={e => {
            setPriceValues({
              start: Number(e.target.value),
              end: Number(end),
              min: min,
              max: max,
            })
          }}
        />
      </div>
      <div className="relative flex-1">
        <p className="pointer-events-none absolute left-4 top-1/2 mb-0 -translate-y-1/2 text-neutral-500">
          Max:
        </p>
        <input
          type="number"
          placeholder={max ? max.toString() : ''}
          className="w-full rounded-xl border border-neutral-300 bg-white py-3 pl-14 pr-4 focus:border-teal-green focus:outline-none"
          min={min ? removeDecimals(min) : undefined}
          max={max ? removeDecimals(max) : undefined}
          value={removeDecimals(end)}
          onChange={e => {
            setPriceValues({
              start: Number(start),
              end: Number(e.target.value),
              min: min,
              max: max,
            })
          }}
        />
      </div>
    </div>
  )
}

export default PriceRangeFilter
